<template>
  <div>
    <base-input :label="searchLabel">
      <el-select
        ref="contactSearch"
        v-model="contactId"
        filterable
        placeholder="Name"
        remote
        :remote-method="searchContacts"
        :loading="searching"
        allow-create
        default-first-option
        @change="onContactSelection"
      >
        <el-option
          v-for="contact in contacts"
          :key="contact.id"
          :label="$options.filters.decode(contact.name)"
          :value="contact.id"
        ></el-option>
      </el-select>
    </base-input>

    <contact-create-form
      :account-id="accountId"
      :preset-name="contactCreateName"
      @create-contact="contactCreated"
      @hidden="onContactCreateFormHidden"
    ></contact-create-form>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import moment from "moment";
import ContactCreateForm from "./ContactCreateForm";
import { get } from "dot-prop";
import _ from "underscore";

export default {
  name: "find-or-create-contact-form",
  components: {
    ContactCreateForm,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    accountId: {
      type: String,
      description: "Account ID",
      required: true,
    },
    searchLabel: {
      type: String,
      description: "Search label",
      required: false,
      default: "Name",
    },
    value: {
      type: String,
    },
    excludeContactIds: {
      type: Array,
      description: "Contact IDs to exclude from search results",
      required: false,
      default: () => {
        return [];
      },
    },
    presetContact: {
      type: Object,
      description: "Existing contact, used for edit forms",
      required: false,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      contactId: null,
      isNewContact: false,
      searching: false,
      contacts: [],
      creating: false,
      errorMessage: null,
      contactCreateName: null,
    };
  },
  watch: {
    contactId(val) {
      if (!val) {
        this.$emit("input", val);
      } else if (typeof val === "string" && val.startsWith("ctc_")) {
        this.$emit("input", val);
      }
    },
  },
  mounted() {
    if (this.presetContact && this.presetContact.id) {
      this.contacts.push(this.presetContact);
      this.contactId = this.presetContact.id;
    }
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        // focus on input
        this.$refs.contactSearch.focus();
      });
    },
    onContactCreateFormHidden() {
      // clear the value if not set
      if (!this.contactId.startsWith("ctc_")) {
        this.contactId = null;
      } else {
        this.$nextTick(() => {
          // otherwise - blur the input (done)
          this.$refs.contactSearch.blur();
        });
      }
    },
    searchContacts(query) {
      if (query !== "") {
        this.searching = true;
        this.axios
          .get(`/v1/accounts/${this.accountId}/contacts?name=~${query}`)
          .then((response) => {
            this.searching = false;

            // exclude contact IDs from response
            this.contacts = _.reject(response.data, (item) => {
              return _.contains(this.excludeContactIds, item.id);
            });
          })
          .catch((err) => {
            console.error("error: ", err); // TODO: handle error better
            this.searching = false;
          });
      } else {
        this.options = [];
      }
    },
    onContactSelection(selectedValue) {
      if (!selectedValue.startsWith("ctc_")) {
        // this is a new contact - open the modal
        this.contactCreateName = selectedValue;
        this.$bvModal.show("contact-create-modal");
      }
    },
    contactCreated(result) {
      // set as contactId result
      this.contacts.push(result);
      this.contactId = result.id;
    },
  },
};
</script>
